import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { BsdirPageLink } from 'Douleutaras/types/bsdir';
import { RootState } from 'Douleutaras/redux/store';

const bsdirPageLinksAdapter = createEntityAdapter<JSONApiDataObject<BsdirPageLink>>({
  selectId: item => item.id
});

export const bsdirPageLinksSlice = createSlice({
  name: 'bsdirPageLinks',
  initialState: bsdirPageLinksAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<BsdirPageLink>),
  reducers: {
    bsdirPageLinksAdded: (state, action) => {
      bsdirPageLinksAdapter.setMany(state, action.payload);
    }
  }
});

export const bsdirPageLinksSelectors = bsdirPageLinksAdapter.getSelectors(
  (state: RootState) => state.bsdir.pageLinks);
export default bsdirPageLinksSlice.reducer;
